import { HttpClient, HttpParams, HttpUrlEncodingCodec } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { REST_BASE_URL } from '../app.config';
import { AntragNachDownload } from '../models/antrag.nach.download';

@Injectable()
export class AntragService {

  private _wasPdfOpened$ = new BehaviorSubject(false);
  private _latestPdfUrl$ = new BehaviorSubject<string | null>(null);

  constructor(private http: HttpClient) {
  }

  retrieveAntragFromDownloadCache(antragId: string, sprache: string): Observable<AntragNachDownload> {
    const params = new HttpParams().set('sprache', sprache);
    const antragIdEnc = new HttpUrlEncodingCodec().encodeValue(antragId);
    return this.http.get<AntragNachDownload>(REST_BASE_URL + '/antrag-download/cache/antrag/' + antragIdEnc, { params });
  }

  /**
   * Erzeugen eines PDF, das dann als Antwort zurückgegeben wird (nur in Videx relevant).
   *
   * @param antrag
   * @param {string} language
   * @returns {Observable<any>}
   */
  getPdf(antrag: any, language: string): Observable<any> {
    const params = new HttpParams().set('language', language);

    return this.http.post(REST_BASE_URL + '/visum-antrag/pdf', antrag, {
      params,
      observe: 'response',
      responseType: 'blob'
    });
  }

  set pdfOpened(value: boolean) {
    this._wasPdfOpened$.next(value);
  }

  get pdfOpened() {
    return this._wasPdfOpened$.value;
  }

  set latestPdfUrl(url: string) {
    this._latestPdfUrl$.next(url);
  }

  get latestPdfUrl() {
    return this._latestPdfUrl$.value;
  }

  /**
   * Direktes Drucken des PDF - Keine Rückgabe eines PDF an den Client (nur in der MEK relevant).
   *
   * @param antrag
   * @param {string} language
   * @returns {Observable<any>}
   */
  printPdf(antrag: any, language: string): Observable<any> {
    const params = new HttpParams().set('sprache', language);

    return this.http.post(REST_BASE_URL + '/mek-visum-antrag/print', antrag, {
      params
    });
  }
}
